import { SearchParams } from "../entry/local/movie";
import { videoService } from "../services/video-service";

export const videoRepo = {
    getDetails: async (id: number) => {
        return await videoService.getDetails(id);
    },
    getDownloadOptions: async (id: number) => {
        return await videoService.getDownloadOptions(id);
    },
    getRelatedMovies: async (id: number) => {
        return await videoService.getRelatedMovies(id);
    },
    likeMovie: async (id: number, action: 'like' | 'dislike') => {
        return await videoService.likeMovie(id, action);
    },
    getSearchFilters: async () => {
        return await videoService.getSearchFilters();
    },
    search: async (searchParams: SearchParams, cancelSignal?: AbortSignal) => {
        return await videoService.search(searchParams, cancelSignal);
    },
    getTaxonomyInfo: async (type: 'genre' | 'country' | 'network' | 'language' | 'release', slug: string) => {
        return await videoService.getTaxonomyInfo(type, slug);
    },
    addReport: async (movieId: number, title: string, reason: string) => {
        return await videoService.addReport(movieId, title, reason);
    },
    getReports: async (page: number) => {
        return await videoService.getReports(page);
    },
    addComment: async (movieId: number, comment: string, parentId?: number, isSpoiler?: boolean, isReview?: boolean, score?: number) => {
        return await videoService.addComment(movieId, comment, parentId, isSpoiler, isReview, score);
    },
    getComments: async (movieId: number, isReview: 'true' | 'false', page: number) => {
        return await videoService.getComments(movieId, isReview, page);
    },
    likeComment: async (commentId: number, action: 'like' | 'dislike') => {
        return await videoService.likeComment(commentId, action);
    },
    getPlayerData: async (id: number, season: number, episode: number) => {
        return await videoService.getPlayerData(id, season, episode);
    },
};